import { render, staticRenderFns } from "./create-sub-task-form.vue?vue&type=template&id=88b9c194&"
import script from "./create-sub-task-form.vue?vue&type=script&lang=js&"
export * from "./create-sub-task-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports